import moment from "moment";
import { resetError, setError } from "./errors";
import request from './utils/request';
import { multipliersVat, urls } from "../constants/app";
import { sendRequestToConnector } from "./utils/sendRequestToConnector";
import QRCode from 'qrcode-generator';
import { fetchSettings } from "./app";
import { isEmpty } from "lodash";
import { comparisonVersionExtension, roundToFixed } from "../utils/common";

const getOperator = (user, cashier, forceCashier) => {
    if (forceCashier) return forceCashier;
    if (user && user.name && user.inn) return { name: user.name, inn: user.inn};
    if (cashier && cashier.name && cashier.inn) return { name: cashier.name, inn: cashier.inn};
    return null;
}

const formatPhone = (phone) => {
    const firstNum = phone.charAt(0);

    switch (firstNum) {
        case '+': return String(phone);
        case '8': return `+7${phone.slice(1)}`
        default: return `+${phone}`;
    }
}

const generateUUID = () => {
    const random = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    
    return `${random()}${random()}-${random()}-${random()}-${random()}-${random()}${random()}${random()}`;
}

const getWokName = (good) => {
    const data = [];

    if (good.wokData.meat) {
        Object.values(good.wokData.meat).forEach((item) => {
            return data.push(getGoodName(item));
        })
    }

    if (good.wokData.topping) {
        Object.values(good.wokData.topping).forEach((item) => {
            return data.push(getGoodName(item));
        })
    }

    if (good.wokData.souce) {
        Object.values(good.wokData.souce).forEach((item) => {
            return data.push('соус ' + getGoodName(item));
        })
    }

    return `${good.wokData.main.title} ${data && data.length > 0 ? `(${data.join(', ')})` : ''}`;
}

const getGoodName = (good) => {
    if (good.title) return good.title;
    if (good.data && good.data.title) return good.data.title;
    if (good.wokData && good.wokData.main && good.wokData.main.title) return getWokName(good);
    return 'Товар неопределен';
}

const getMarkedGood = (item) => {
    const result = item.markedCodes.map((code) => {
        return {
            ...item,
            count: 1,
            markedCodes: [code],
        }
    });
    return result;
}

const getItems = (order, ffd, getMark, ignoreMarkedCodes) => {
    let saleSum = parseFloat(order.goodsPrice) + parseFloat(order.deliveryPrice || 0) - order.totalPrice;

    const goods = (ignoreMarkedCodes || !getMark) ? order.goods : order.goods.flatMap((item) => {
        if (!item.markedCodes || item.markedCodes.length <= 1) return item;
        return getMarkedGood(item);
    });

    let items = goods.map((item, index) => {
        const itemPrice = (item.wokData && item.wokData.price) ? item.wokData.price : item.price;
        const price = parseFloat(itemPrice) - (Math.ceil(saleSum * (+parseFloat(itemPrice * item.count).toFixed(2) / order.goodsPrice) / item.count));
        let vat = null
        if (order.vat === 'goods') {
            vat = {
                type: item.vat || 'none',
                sum: +(parseFloat((price) * item.count).toFixed(2) * multipliersVat[item.vat || 'none'] / (multipliersVat[item.vat || 'none'] + 1)).toFixed(2),
            };
        } else {
            vat = {
                type: order.vat || 'none',
                sum: +(parseFloat((price) * item.count).toFixed(2) * multipliersVat[order.vat || 'none'] / (multipliersVat[order.vat || 'none'] + 1)).toFixed(2),
            };
        }

        const result = {
            index,
            type: 'position',
            name: getGoodName(item),
            price: price,
            quantity: item.count,
            amount: +parseFloat((price) * item.count).toFixed(2),
            paymentMethod: "fullPayment",
            tax: vat,
            paymentObject: item.excise ? 'excise' : 'commodity',
            measurementUnit: ffd === 1.05 ? "шт." : "piece",
            piece: true,
            sale: Math.ceil(saleSum * (+parseFloat(itemPrice * item.count).toFixed(2) / order.goodsPrice) / item.count)
        }

        if (!ignoreMarkedCodes && getMark && item.markedCodes  && item.markedCodes.length > 0) {
            if (ffd === 1.05) return {error: {error_message: 'ФФД < 1.2. Продажа маркированных товаров невозможна.'}}
            const code = item.markedCodes[0];

            if (!isValidMarkingCode(code)) {
                console.error(`Некорректный код маркировки для товара "${getGoodName(item)}": ${item.markedCodes[0]} -> ${code}`);
            } else {
                result.imcParams = {
                    imc: code,
                    imcModeProcessing: 0,
                    imcType: "auto",
                    itemEstimatedStatus: 'itemPieceSold',
                };
            }
        }

        if (!ignoreMarkedCodes && getMark && item.typeMarked === 'horeca' && item.gtin) {
            result.imcParams = {
                imc: btoa(item.gtin),
                imcModeProcessing: 0,
                imcType: "auto",
                itemEstimatedStatus: 'itemPieceSold',
            };

            result.additionalAttribute = "crpt=mrk&mode=horeca&m=0";
        }

        return result;
    });

    let checkSale = 0;
    items.forEach((el) => {
        checkSale += el.sale * el.quantity;
    })
    
    const differenceSale = checkSale - saleSum;

    if(differenceSale !== 0) {
        let maxPriceItem = items[0];
        items.forEach((el) => {
            if (el.price > maxPriceItem.price) {
                maxPriceItem = el;
            }
        });
        items = items.map((el) => {
            if(el.index === maxPriceItem.index) {
                const count = el.quantity - 1;
                el.quantity = count;
                el.amount = count > 0 ? el.price * count : null;
                el.tax = count > 0 ? {
                    type: el.tax.type,
                    sum: +(parseFloat((el.price) * count).toFixed(2) * multipliersVat[el.tax.type || 'none'] / (multipliersVat[el.tax.type || 'none'] + 1)).toFixed(2),
                } : null;
            }
            return el;
        }).filter((el) => el.quantity > 0);

        items.push({
            type: 'position',
            name: maxPriceItem.name,
            price: maxPriceItem.price + differenceSale,
            quantity: 1,
            amount: maxPriceItem.price + differenceSale,
            paymentMethod: "fullPayment",
            paymentObject: maxPriceItem.excise ? 'excise' : 'commodity',
            piece: true,
            tax: {
                type: (maxPriceItem.tax && maxPriceItem.tax.type) ? maxPriceItem.tax.type : 'none',
                sum: +(parseFloat((maxPriceItem.price + differenceSale)).toFixed(2) * multipliersVat[(maxPriceItem.tax && maxPriceItem.tax.type) ? maxPriceItem.tax.type : 'none'] / (multipliersVat[(maxPriceItem.tax && maxPriceItem.tax.type) ? maxPriceItem.tax.type : 'none'] + 1)).toFixed(2),
            },
            measurementUnit: ffd === 1.05 ? "шт." : "piece",
        })
    }

    if(order.deliveryPrice && parseFloat(order.deliveryPrice) > 0) {
        items.push({
            type: 'position',
            name: 'Доставка',
            price: +parseFloat(order.deliveryPrice).toFixed(2),
            quantity: 1,
            amount: +parseFloat(order.deliveryPrice).toFixed(2),
            paymentMethod: "fullPayment",
            paymentObject: 'service',
            tax: {
                type: 'none',
                sum: 0,
            },
            piece: true,
            measurementUnit: ffd === 1.05 ? "шт." : "piece",
        });
    }
    return items.map((item) => {
        delete item.sale;
        delete item.index;
        return item;
    });
}

const getTaxesOrder = (order) => {
    let taxes = []
    if (order.vat === 'goods') {
        order.goods.forEach((item) => {
            taxes.push({
                type: item.vat || 'none',
                sum: +(parseFloat((item.price) * item.count).toFixed(2) * multipliersVat[item.vat || 'none'] / (multipliersVat[item.vat || 'none'] + 1)).toFixed(2),    
            });
        });
    } else {
        taxes = [{
            type: order.vat || 'none',
            sum: +(parseFloat((order.totalPrice)).toFixed(2) * multipliersVat[order.vat || 'none'] / (multipliersVat[order.vat || 'none'] + 1)).toFixed(2),
        }];
    }
    return taxes;
}

const generateQRForAtolPrinting = (link) => {
    const qr = QRCode(0, 'L');
    qr.addData(link);
    qr.make();

    const moduleSize = 4;
    const margin = 4;
    const qrSize = qr.getModuleCount();
    const outputSize = qrSize + margin * 2;

    function createPixelArray(qrInstance, moduleSize, margin) {
        const width = outputSize * moduleSize;
        const height = width;
        const bytesPerRow = Math.ceil(width / 8);
        const pixels = new Array(Math.ceil(height / 8))
            .fill()
            .map(() => new Array(bytesPerRow).fill(0));

        for (let i = 0; i < height; i++) {
            for (let j = 0; j < width; j++) {
                const moduleX = Math.floor(j / moduleSize) - margin;
                const moduleY = Math.floor(i / moduleSize) - margin;
                let isBlack = false;

                if (moduleX >= 0 && moduleX < qrSize && moduleY >= 0 && moduleY < qrSize) {
                    isBlack = qrInstance.isDark(moduleY, moduleX);
                }

                pixels[i * width + j] = isBlack ? 0xFF : 0x00;
            }
        }

        return pixels;
    }

    const pixelArray = createPixelArray(qr, moduleSize, margin);
    const base64Data = btoa(String.fromCharCode(...pixelArray)); 
    const width = outputSize * moduleSize;

    return { base64Data, width };
};

const getPostItemsSell = (type, items) => {
    if (type === 'sell') {
        let result = [];
        let qr = null;

        if (items.qr && items.qr !== '') qr = generateQRForAtolPrinting(items.qr);

        if (items.firstText && items.firstText !== '') {
            result.push({
                type: 'text',
                text: items.firstText,
                alignment: 'left',
                wrap: 'words'
            });
        }

        if (qr && qr.width && qr.base64Data) {
            result.push({
                type: 'pixels',
                width: qr.width,
                pixels: qr.base64Data,
            });
        }

        if (items.secondText && items.secondText !== '') {
            result.push({
                type: 'text',
                text: items.secondText,
                alignment: 'left',
                wrap: 'words'
            });
        }

        if (items.fiscalPointText && items.fiscalPointText !== '') {
            result.push({
                type: 'text',
                text: items.fiscalPointText,
                alignment: 'left',
                wrap: 'words'
            });
        }

        return result;
    };
    return null;
};

const generateReceiptSell = async (data, point, user, type, sno, post, ignoreMarkedCodes) => {
    const order = data.order;

    const items = await getItems(order, data.ffd, type === 'sell', ignoreMarkedCodes);
    if (items.error) return items.error;
    const params = {};
    params.uuid = generateUUID();
    const postItems = getPostItemsSell(type, post);
    params.request = [{
        type,
        taxationType: (sno || 'osn'),
        ignoreNonFiscalPrintErrors: true,
        paymentsPlace: `${point.street}, ${point.house}`,
        items: [...items],
        payments: [{
            type: order.payment === 'terminal' ? 'electronically' : 'cash',
            sum: +parseFloat(order.totalPrice).toFixed(2)
        }],
        total: +parseFloat(order.totalPrice).toFixed(2),
        postItems: postItems,
    }];

    if (order.phone && formatPhone(order.phone)) {
        params.request[0].clientInfo = {
            emailOrPhone: formatPhone(order.phone)
        }
    }
    const currentUser = getOperator(user, data.cashier, data.forceCashier);

    if (currentUser && currentUser.name && currentUser.inn) params.request[0].operator = currentUser;

    return params;
}

const generateCorrection = async (data, point, user, sno) => {
    const order = data.order;
    const params = {};
    params.uuid = generateUUID();
    if (data.ffd === 1.05) {
        params.request = [{
            type: data.type,
            correctionType: data.correctionType || 'self',
            correctionBaseDate: String(moment().format('YYYY.MM.DD')),
            payments: [{
                type: order.payment === 'terminal' ? 'electronically' : 'cash',
                sum: +parseFloat(order.totalPrice).toFixed(2)
            }],
            taxes: getTaxesOrder(order),
            total: +parseFloat(order.totalPrice).toFixed(2),
        }];

        if (data.correctionType === 'instruction') params.request[0].correctionBaseNumber = data.correctionNumber;

        const currentUser = getOperator(user, data.cashier, data.forceCashier);
        if (currentUser && currentUser.name && currentUser.inn) params.request[0].operator = currentUser;

        return params;
    }

    const items = await getItems(order, data.ffd);    
    params.request = [{
        type: data.type,
        taxationType: (sno || 'osn'),
        correctionType: data.correctionType || 'self',
        correctionBaseDate: String(moment().format('YYYY.MM.DD')),
        ignoreNonFiscalPrintErrors: true,
        paymentsPlace: `${point.street}, ${point.house}`,
        items: [...items],
        payments: [{
            type: order.payment === 'terminal' ? 'electronically' : 'cash',
            sum: +parseFloat(order.totalPrice).toFixed(2)
        }],
        total: +parseFloat(order.totalPrice).toFixed(2)
    }];

    if (order.phone && formatPhone(order.phone)) {
        params.clientInfo = {
            emailOrPhone: formatPhone(order.phone)
        }
    }

    if (data.correctionType === 'instruction') params.request[0].correctionBaseNumber = data.correctionNumber;

    const currentUser = getOperator(user, data.cashier, data.forceCashier);
    if (currentUser && currentUser.name && currentUser.inn) params.request[0].operator = currentUser;

    return params;
}

export function setWorkingShift(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_WORKING_SHIFT', data: data});
    }
}

export function setWorkingShifts(data) {    
    return (dispatch) => {
        dispatch({ type: 'SET_WORKING_SHIFTS', data: data});
    }
}

export function setOtherExpenditures(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_OTHER_EXPENDITURES', data: data});
    }
}

export function fetchWorkingShift() {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'workingShift', value: true });
        const filials = getState().handbook.filials;
        const filters = getState().cassa.filters;

        const params = {}
        const dataParams = {}

        if(filters.point) {
            dataParams['point.id'] = filters.point.value;
            params['point.id'] = filters.point.value;
        }

        if (filters.id) {
            dataParams['id'] = filters.id;
            params['id'] = filters.id;
        }

        if (filters.createdStartDate) params['created_at_gte'] = new Date(filters.createdStartDate);
        if (filters.createdEndDate) params['created_at_lte'] = new Date(filters.createdEndDate);

        dataParams['_sort'] = `created_at:desc`;
        params['_sort'] = `created_at:desc`;

        if(!filters.point && filials.length > 0) {
            dataParams['point.id'] = filials[0].id;
            params['point.id'] = filials[0].id;
        }

        if(!filters.point && (filials.length === 0 || !filials[0])) {
            dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            return null;
        }


        if(!filters.createdStartDate && !filters.createdEndDate) {
            params['closed_at_null'] = true;
            try {
                dispatch(setWorkingShift(null));
                dispatch(setWorkingShifts(null));
                let workingShift = await request({ method: 'get', url: urls.workingShift, params });
                if(workingShift && workingShift.length > 0) {
                    dispatch(setWorkingShift(workingShift[0]));                    
                } else {
                    const shifts = await request({ method: 'get', url: urls.workingShift, params: {...dataParams} });
                    if (shifts && shifts.length > 0) {
                        workingShift = await shifts.reduce((latest, current) => {
                            return new Date(current.closed_at) > new Date(latest.closed_at) ? current : latest;
                        });
                        dispatch(setWorkingShift(workingShift));
                    } else {
                        dispatch(setWorkingShift(null));
                    }
                }
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            } catch(error) {
                dispatch(setError(error, 'workingShift'));
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            }
        } else {
            try {
                dispatch(setWorkingShift(null));
                dispatch(setWorkingShifts(null));
                let workingShifts = await request({ method: 'get', url: urls.workingShift, params });
                dispatch(setWorkingShifts(workingShifts));
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            } catch(error) {
                dispatch(setError(error, 'workingShift'));
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            }
        }        
    }
}

export function deleteWorkingShift(id) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'workingShift', value: true });
        try {
            return request({ method: 'delete', url: `${urls.workingShift}/${id}` })
            .then((res) => {
                if (res && !res.error) dispatch(fetchWorkingShift())
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            });
        } catch (err) {
            dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            console.error(err);
        }
    }
}

export function fetchOtherExpenditures() {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: true });
        const filials = getState().handbook.filials;
        const filters = getState().cassa.filters;

        const params = {}

        if(filters.point) {
            params['point.id'] = filters.point.value;
        }

        if (filters.id) {
            params['id'] = filters.id;
        }

        if (filters.createdStartDate) {
            params['visible_datetime_gte'] = moment(filters.createdStartDate).format('YYYY-MM-DD HH:mm:ss');            
        } else {
            params['visible_datetime_gte'] = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
        }

        if (filters.createdEndDate) {
            params['visible_datetime_lte'] = moment(filters.createdEndDate).format('YYYY-MM-DD HH:mm:ss');
        } else {
            params['visible_datetime_lte'] = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
        }

        params['_sort'] = `visible_datetime:desc`;
        params['_limit'] = 200;

        if(!filters.point && filials.length > 0) {
            params['point.id'] = filials[0].id;
        }

        if(!filters.point && (filials.length === 0 || !filials[0])) {
            dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: false });
            return null;
        }

        try {
            const otherExpenditures = await request({ method: 'get', url: urls.otherExpenditures, params });
            dispatch(setOtherExpenditures(otherExpenditures));
            dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: false });
        } catch(error) {
            dispatch(setError(error, 'otherExpenditures'));
            dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: false });
        }      
    }
}

export function setCassaFilters(filters) {
    return dispatch => {
        dispatch({ type: 'SET_CASSA_FILTERS', filters });
    }
}

export function setTypeMovementCash(typeMovementCash) {    
    return dispatch => {
        dispatch({ type: 'SET_TYPE_MOVEMENT_CASH', typeMovementCash });
    }
}

export function addArticleWorkingShift(article, workingShiftId, getWorkingShift = true) {
    return async (dispatch, getState) => {
        const user = getState().user.info;
        const id = workingShiftId ? workingShiftId : getState().cassa.workingShift.id;
        if (id && article) {
            article.author = user.name ? user.name : user.username;
            article.sum = roundToFixed(article.sum);
            if(!article.visible_datetime) article.visible_datetime = new Date();

            const data = { workingShiftId: id, article }

            dispatch({ type: 'SET_LOADER', field: 'workingShift', value: true });
            return request({ method: 'post', url: `${urls.workingShift}/addArticleWorkingShift`, data })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                if (getWorkingShift) dispatch(fetchWorkingShift());
                return true;
            })
            .catch((error) => {
                dispatch(setError(error, 'workingShift'));
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            });
        }
    }
}

export function refundArticle(data) {
    return async (dispatch) => {
        return request({ method: 'post', url: `${urls.workingShift}/refundArticle`, data })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                if (response && response.error) {
                    dispatch(setError(response.error, 'workingShift'));
                    return false;
                }
                dispatch(fetchWorkingShift());
                return true;
            })
            .catch((error) => {
                dispatch(setError(error, 'workingShift'));
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                return false;
            });
    }
}

export function updateArticleWorkingShift(article) {
    return async (dispatch, getState) => {
        const id = getState().cassa.workingShift.id;
        const data = await request({ method: 'get', url: `${urls.workingShift}/${id}` });

        if(!data.articlesCashes) {
            data.articlesCashes = []
        }

        data.articlesCashes = data.articlesCashes.filter(item => item.id !== article.id);
        data.articlesCashes.push(article);
        data.articlesCashes = data.articlesCashes.sort((a, b) => a.id - b.id);

        if(data && data.id && article) {
            dispatch({ type: 'SET_LOADER', field: 'workingShift', value: true });
            request({ method: 'put', url: `${urls.workingShift}/${id}`, data: { articlesCashes: data.articlesCashes } })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                dispatch(fetchWorkingShift());
            })
            .catch((error) => {
                dispatch(setError(error, 'workingShift'));
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            });
        }
    }
}

export function deleteArticleWorkingShift(article) {
    return async (dispatch, getState) => {
        const id = getState().cassa.workingShift.id
        if (id && article) {
            const data = await request({ method: 'get', url: `${urls.workingShift}/${id}` });
            if(!data.articlesCashes) {
                data.articlesCashes = [];
            }

            data.articlesCashes = await data.articlesCashes.filter(item => item.id !== article.id);
            data.articlesCashes = data.articlesCashes.sort((a, b) => a.id - b.id);

            switch(article.typeMovementCash) {
                case ('income'): {
                    if(article.typeTransaction === 'cash') {
                        data.depositingCash = (parseFloat(data.depositingCash || 0) - parseFloat(article.sum)).toFixed(2);
                    } else {
                        data.depositingNoncash = (parseFloat(data.depositingNoncash || 0) - parseFloat(article.sum)).toFixed(2);
                    }
                    break;
                }
                case ('expenditure'): {
                    if(article.typeTransaction === 'cash') {
                        data.withdrawalCash = (parseFloat(data.withdrawalCash || 0) - parseFloat(article.sum)).toFixed(2);
                    } else {
                        data.withdrawalNoncash = (parseFloat(data.withdrawalNoncash || 0) - parseFloat(article.sum)).toFixed(2);
                    }
                    break;
                }
                case ('incasso'): {
                    data.incassoCash = (parseFloat(data.incassoCash || 0) - parseFloat(article.sum)).toFixed(2);
                    break;
                }
                default: break;
            }

            dispatch({ type: 'SET_LOADER', field: 'workingShift', value: true });
            request({ method: 'put', url: `${urls.workingShift}/${id}`, data })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                dispatch(fetchWorkingShift());
            })
            .catch((error) => {
                dispatch(setError(error, 'workingShift'));
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            });
        }
    }
}

export function addOtherExpenditure(article) {
    return (dispatch, getState) => {
        const user = getState().user.info;
        const filters = getState().cassa.filters;
        const filials = getState().handbook.filials;

        if(!filters.point && filials.length > 0) {
            article.point = filials[0].id;
        }

        if(filters.point) {
            article.point = filters.point.value;
        }

        if(!filters.point && (filials.length === 0 || !filials[0])) {
            dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: false });
            return null;
        }

        article.author = user.name ? user.name : user.username;
        article.sum = parseFloat(article.sum).toFixed(2);

        if(article) {
            dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: true });
            request({ method: 'post', url: `${urls.otherExpenditures}`, data: article })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: false });
                dispatch(fetchOtherExpenditures());
            })
            .catch((error) => {
                dispatch(setError(error, 'otherExpenditures'));
                dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: false });
            });
        }
    }
}

export function updateOtherExpenditure(article) {
    return (dispatch) => {
        if(article && article.id) {
            dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: true });
            request({ method: 'put', url: `${urls.otherExpenditures}/${article.id}`, data: article })
            .then((response) => {
                dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: false });
                dispatch(fetchOtherExpenditures());
            })
            .catch((error) => {
                dispatch(setError(error, 'otherExpenditures'));
                dispatch({ type: 'SET_LOADER', field: 'otherExpenditures', value: false });
            });
        }
    }
}

const getDevice = async (paramsDevice) => {
    const devices = await request({ method: 'get', url: `${urls.devices}`, params: paramsDevice});
    return devices[0];
}

const getDataWorkingShift = async (shift, type) => {
    const calculateTotalRevenue = (data, articles, paymentMethod) => {
        if (!Array.isArray(data)) return 0;

        let total = 0;
        
        const ordersTotal = data.reduce((acc, item) => {                
            if (item.payment === paymentMethod) {
                return acc + parseFloat(item.totalPrice || 0);
            } else {
                return acc;
            }
        }, 0).toFixed(2);

        if (ordersTotal) total += parseFloat(ordersTotal);

        if (!articles || articles.length === 0) return total;

        const filteredArticles = articles.filter((article) => {
            if (paymentMethod === 'terminal') {
                if (article.typeTransaction === 'noncash') return true;
                return false;
            } else {
                if (article.typeTransaction === 'cash') return true;
                return false;
            }
        });

        if (!filteredArticles || filteredArticles.length === 0) return total;

        const articlesSum = filteredArticles.reduce((acc, item) => {
            if (item.sum) return acc + parseFloat(item.sum);
            return acc;
        }, 0).toFixed(2);

        if (articlesSum) total -= parseFloat(articlesSum);

        return total;
    };

    const calculateArticles = (articles) => {
        return (articles || []).reduce((acc, article) => {
            switch(article.typeMovementCash) {
                case ('income'): {
                    if(article.typeTransaction === 'cash') {
                        acc.depositingCash += +roundToFixed(article.sum);
                    } else {
                        acc.depositingNoncash = +roundToFixed(article.sum);
                    }
                    break;
                }
                case ('expenditure'): {
                    if(article.typeTransaction === 'cash') {
                        acc.withdrawalCash += +roundToFixed(article.sum);
                    } else {
                        acc.withdrawalNoncash += +roundToFixed(article.sum);
                    }
                    break;
                }
                case ('incasso'): {
                    acc.incassoCash += +roundToFixed(article.sum);
                    break;
                }
                default: break
            };
            return acc;
        }, { depositingCash: 0, depositingNoncash: 0, withdrawalCash: 0, withdrawalNoncash: 0, incassoCash: 0 })
    }

    const threeMonthsAgo = moment().subtract(3, 'months');
    const isRecentShift = moment(shift.created_at).isAfter(threeMonthsAgo);        
    const orderType = isRecentShift ? 'orders' : 'archive';

    const ordersParams = {
        workingShiftId: shift.id || null,
        payments: ['cash', 'terminal'],
        type: orderType,
    };
    
    const ordersData = await request({ method: 'post', url: `${urls.workingShift}/ordersList`, data: ordersParams });
    const orders = ordersData || [];

    if (type === 'changeActivate') {
        const articlesRefundRevenue = (shift.articlesCashes || []).filter((article) => article.typeMovementCash === 'refund_revenue')
        const revenueCash = calculateTotalRevenue(orders, articlesRefundRevenue, 'cash');
        const revenueNoncash = calculateTotalRevenue(orders, articlesRefundRevenue, 'terminal');
        
        const finalBalanceCash = parseFloat(shift.initialBalanceCash || 0) + parseFloat(revenueCash) + parseFloat(shift.depositingCash || 0) - parseFloat(shift.withdrawalCash || 0) + parseFloat(shift.incassoCash || 0);
        const finalBalanceNoncash = parseFloat(shift.initialBalanceNoncash || 0) + parseFloat(revenueNoncash) + parseFloat(shift.depositingNoncash || 0) - parseFloat(shift.withdrawalNoncash || 0);
    
        return { revenueCash, revenueNoncash, finalBalanceCash, finalBalanceNoncash }
    }

    const prevShiftParams = {
        'point.id': shift.point.id,
        _sort: 'closed_at:desc',
        _limit: 1,
    }

    if (shift.closed_at) prevShiftParams.closed_at_lt = shift.closed_at;
    const prevShiftData = await request({ method: 'get', url: `${urls.workingShift}`, params: prevShiftParams });

    let prevShift;
    if (prevShiftData && !isEmpty(prevShiftData[0])) prevShift = prevShiftData[0];
    let initialBalanceCash = 0;
    let initialBalanceNoncash = 0;
    
    if (prevShift) {
        if (prevShift.finalBalanceCash) initialBalanceCash = roundToFixed(prevShift.finalBalanceCash);
        if (prevShift.finalBalanceNoncash) initialBalanceNoncash = roundToFixed(prevShift.finalBalanceNoncash);
    }

    const articlesRefundRevenue = (shift.articlesCashes || []).filter((article) => article.typeMovementCash === 'refund_revenue')
    const revenueCash = calculateTotalRevenue(orders, articlesRefundRevenue, 'cash');
    const revenueNoncash = calculateTotalRevenue(orders, articlesRefundRevenue, 'terminal');

    const dataArticles = calculateArticles(shift.articlesCashes);
    const { depositingCash, depositingNoncash, withdrawalCash, withdrawalNoncash, incassoCash } = dataArticles;

    const finalBalanceCash = roundToFixed(parseFloat(initialBalanceCash || 0) + parseFloat(revenueCash) + parseFloat(depositingCash || 0) - parseFloat(withdrawalCash || 0) + parseFloat(incassoCash || 0));
    const finalBalanceNoncash = roundToFixed(parseFloat(initialBalanceNoncash || 0) + parseFloat(revenueNoncash) + parseFloat(depositingNoncash || 0) - parseFloat(withdrawalNoncash || 0));

    return { initialBalanceCash, initialBalanceNoncash, revenueCash, revenueNoncash, depositingCash, depositingNoncash, withdrawalCash, withdrawalNoncash, incassoCash, finalBalanceCash, finalBalanceNoncash }
}

export function recalculationWorkingShift(shift) {
    return async (dispatch) => {
        if (isEmpty(shift)) {
            dispatch(setError({ status: 400, message: 'Не передана смена.'}, 'workingShift'));
            return;
        }

        dispatch({ type: 'SET_LOADER', field: 'workingShift', value: true });
        const data = await getDataWorkingShift(shift, 'reaclculation');

        if (!isEmpty(data)) {
            const result = await request({ method: 'put', url: `${urls.workingShift}/${shift.id}`, data });
            if (result) {
                dispatch(fetchWorkingShift());
            } else {
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            }
        } else {
            dispatch(setError({ status: 400, message: 'Не удалось провести перерасчет.'}, 'workingShift'));
            dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
        }
    }
}

export function changeActivateWorkingShift(id, point, sendKKT) {
    return async (dispatch, getState) => {
        const user = getState().user.info;
        const userName = user.name ? user.name : user.username;
        let atolResult;

        const paramsDevice = {};
        paramsDevice["point.id"] = parseInt(point.value);

        dispatch({ type: 'SET_LOADER', field: 'workingShift', value: true });

        const device = await getDevice(paramsDevice);

        if (!device || !device.login || !device.port) {
            dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            return {
                error: { code: 404, description: 'Нет данных об оборудовании или аккаунте АТОЛ.'}
            };
        }

        const requestAtolData = {
            host: device.host || 'http://127.0.0.1',
            port: device.port || 16732,
            cashier: device.user || null,
            login: device.login || null,
            password: device.password || null,
        }

        const ping = await dispatch(pingExtension());
        if (!ping && sendKKT) {
            dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            return {error: { message: `101. Не удалось установить соединение с расширением. Проверьте установлено ли у Вас расширение "CRM.ККТ.Соединение" версии не менее чем 2.2.1 и обновите страницу.` }}
        }
        const versionExtension = ping && ping.version ? ping.version : null;

        if (id) {
            try {
                const avaibleCloseShift = await request({ method: 'get', url: `${urls.workingShift}/avaibleCloseShift/${id}` });
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                if (avaibleCloseShift.error) return {error: avaibleCloseShift.error};
            } catch (err) {
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                if (err && err.data) {
                    return {
                        error: {
                            code: err.data.statusCode || null,
                            message: err.data.message || 'Неизвестная ошибка'
                        }
                    }
                }
                return err;
            }

            if (sendKKT) {
                atolResult = await dispatch(requestAtol({ ...requestAtolData, type: 'closeShift'}));

                if (atolResult.error && !atolResult.fiscalUUID) {
                    dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                    return {error: atolResult.error};
                }

                if (atolResult && (atolResult.uuid || atolResult.fiscalUUID)) {
                    let taskStatus;
                    if (comparisonVersionExtension(versionExtension, '2.2.2')) {
                        taskStatus = atolResult;
                    } else {
                        taskStatus = await dispatch(requestAtol({ ...requestAtolData, fiscalUUID: atolResult.uuid || atolResult.fiscalUUID, type: 'getTaskResult'}));
                    }
                    let error;
                    if (taskStatus && taskStatus.error) {
                        error = taskStatus.error;
                    } else if (taskStatus && taskStatus.results && taskStatus.results[0]) {
                        const result = taskStatus.results[0];
                        error = result.error;
                    }

                    if (error && error.code) {
                        dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                        return {error};
                    }
                }
            }

            const data = {
                shiftCloser: userName,
                errorKKT: (sendKKT && atolResult && atolResult.error) ? true : false,
            }

            try {
                const result = await request({ method: 'post', url: `${urls.workingShift}/closeShift/${id}`, data });
                const { message, ...workingShift } = result;
                if (!workingShift.error) dispatch(setWorkingShift(workingShift));
    
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
    
                if (workingShift.error) {
                    return {error: workingShift.error}
                } else {
                    const text = [];
                    text.push(message ? message : `Смена №${id} успешно закрыта.`);
                    if (sendKKT && atolResult && atolResult.error) {
                        if (atolResult.error.code || atolResult.error.description) text.push('Ошибка ККТ.');
                        if (atolResult.error.code) text.push(`Код ошибки ККТ: ${atolResult.error.code}.`);
                        if (atolResult.error.description) text.push(`Описание ошибки ККТ: ${atolResult.error.description}.`);
                    }
                    if (message) return { message }
                    return {message: text.join(' ')};
                }
            } catch (err) {
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                if (err && err.data) {
                    return {
                        error: {
                            code: err.data.statusCode || null,
                            message: err.data.message || 'Неизвестная ошибка'
                        }
                    }
                }
                return err;
            }
        } else {
            if (sendKKT) {
                const atolResult = await dispatch(requestAtol({...requestAtolData, type: 'openShift'}));
                if (atolResult.error && !atolResult.fiscalUUID) {
                    dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                    return {error: atolResult.error};
                }

                if (atolResult && (atolResult.uuid || atolResult.fiscalUUID)) {
                    let taskStatus;
                    if (comparisonVersionExtension(versionExtension, '2.2.2')) {
                        taskStatus = atolResult;
                    } else {
                        taskStatus = await dispatch(requestAtol({ ...requestAtolData, fiscalUUID: atolResult.uuid || atolResult.fiscalUUID, type: 'getTaskResult'}));
                    }
                    let error;
                    if (taskStatus && taskStatus.error) {
                        error = taskStatus.error;
                    } else if (taskStatus && taskStatus.results && taskStatus.results[0]) {
                        const result = taskStatus.results[0];
                        error = result.error;
                    }

                    if (error && error.code) {
                        dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                        return {error};
                    }
                }
            }

            const data = {
                point: point.value,
                shiftOpener: userName,
                deviceId: device.id,
                errorKKT: (sendKKT && atolResult && atolResult.error) ? true : false,
            }

            try {
                const result = await request({ method: 'post', url: `${urls.workingShift}/openShift`, data});

                const { message, ...workingShift } = result;
                if (!workingShift.error) dispatch(setWorkingShift(workingShift));

                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });

                if (workingShift.error) {
                    return {error: workingShift.error}
                } else {
                    const text = [];
                    text.push(message ? message : `Смена №${workingShift.id} успешно открыта.`);
                    if (sendKKT && atolResult && atolResult.error) {
                        if (atolResult.error.code || atolResult.error.description) text.push('Ошибка ККТ.');
                        if (atolResult.error.code) text.push(`Код ошибки ККТ: ${atolResult.error.code}.`);
                        if (atolResult.error.description) text.push(`Описание ошибки ККТ: ${atolResult.error.description}.`);
                    }
                    if (message) return { message }
                    return {message: text.join(' ')};
                }
            } catch (err) {
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                if (err && err.data) {
                    return {
                        error: {
                            code: err.data.statusCode || null,
                            message: err.data.message || 'Неизвестная ошибка'
                        }
                    }
                }
                return err;
            }
        }
    }
}

export function getXReport(point) {
    return async (dispatch) => {
        const paramsDevice = {};
        paramsDevice["point.id"] = parseInt(point.value);

        dispatch({ type: 'SET_LOADER', field: 'workingShift', value: true });

        const device = await getDevice(paramsDevice);

        if (!device || !device.login || !device.port) {
            dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
            return {error: 'Нет данных об оборудовании или аккаунте АТОЛ.'};
        }

        const requestAtolData = {
            host: device.host || 'http://127.0.0.1',
            port: device.port || 16732,
            login: device.login,
            password: device.password
        }

        requestAtolData.type = 'reportX'
        const atolResult = await dispatch(requestAtol(requestAtolData));

        dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });

        if (atolResult.error) return {error: atolResult.error};
        return {message: 'X-отчет успешно получен.'}
    }
}

export function setDetailArticle(data) {
    return dispatch => {
        dispatch({ type: 'SET_DETAIL_ARTICLE', data });
    }
}

export function requestAtol(data, withoutLoader, ignoreMarkedCodes, old) {
    return async (dispatch, getState) => {
        const user = getState().user.info;
        const point = data.point ? data.point : data.workingShift ? data.workingShift.point : null;
        const atolData = point ? point.atolData : null;
        await dispatch(fetchSettings(true));
        const postItemsSettings = getState().settings.init.postItemsFiscal;
        let requestData = {};

        let postItems = postItemsSettings || {};
        if (point && point.fiscalText && point.fiscalText !== '') postItems.fiscalPointText = point.fiscalText;

        const request = {
            type: 'api_request',
            data: {
                url: `${data.host}:${data.port}/api/v2/requests`,
                user: data.login,
                password: data.password,
            },
        };

        if (old) {
            delete request.data.url;
            request.data.host = data.host;
            request.data.port = data.port;
        }

        const returnData = (data && data.returnData) ? data.returnData : null;
        if (returnData) request.returnData = returnData;

        const ping = await dispatch(pingExtension());
        if (!ping) return { error: { code: 101, description: 'Не удалось установить соединение с расширением. Проверьте установлено ли у Вас расширение "CRM.ККТ.Соединение" версии не менее чем 2.2.1 и обновите страницу.' }}
        const versionExtension = ping.version;

        switch (data.type) {
            case 'sell':
            case 'buy':
            case 'sellReturn':
            case 'buyReturn': {
                if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'updateorder', value: data.order.id });
                requestData = await generateReceiptSell(data, point, user, data.type, atolData.sno, postItems, ignoreMarkedCodes);
                if (requestData.error) {
                    dispatch({ type: 'SET_LOADER', field: 'updateorder', value: false});
                    return requestData.error;
                }
                if (comparisonVersionExtension(versionExtension, '2.2.2')) request.type = 'handle';
                request.data = {
                    ...request.data,
                    request: {
                        ...requestData
                    },                    
                };
                break;
            }
            case 'sellCorrection': {
                if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'updateorder', value: data.order.id });
                requestData = await generateCorrection(data, point, user, atolData.sno);
                request.data = {
                    ...request.data,
                    request: {
                        ...requestData
                    },                    
                };
                break;
            }
            case 'openShift':
            case 'closeShift': 
            case 'getMarkingCodeValidationStatus':
            case 'cancelMarkingCodeValidation':
            case 'getDeviceInfo':
            case 'acceptMarkingCode': {
                requestData = {
                    uuid: generateUUID(),                    
                    request: [{
                        type: data.type,
                    }],
                }

                const currentUser = getOperator(user, data.cashier, data.forceCashier);
                if (currentUser && currentUser.name && currentUser.inn) requestData.request[0].operator = currentUser;

                if (comparisonVersionExtension(versionExtension, '2.2.2')) request.type = 'handle';
                request.data = {
                    ...request.data,
                    request: {
                        ...requestData,
                    },
                };

                break;
            }
            case 'reportX': {
                requestData = {
                    uuid: generateUUID(),                    
                    request: [{
                        type: data.type,
                    }],
                }

                const currentUser = getOperator(user, data.cashier, data.forceCashier);
                if (currentUser && currentUser.name && currentUser.inn) requestData.request[0].operator = currentUser;

                request.data = {
                    ...request.data,
                    request: {
                        ...requestData,
                    },
                };
                break;
            }
            case 'getTaskResult': {
                request.data.url = `${data.host}:${data.port}/api/v2/requests/${data.fiscalUUID}`;
                break;
            }
            case 'beginMarkingCodeValidation': {
                requestData.request = [{
                    params: {
                        imcType: 'auto',
                        imc: data.code,
                        imcModeProcessing: 0,
                        itemEstimatedStatus: 'itemPieceSold'
                    },
                    type: 'beginMarkingCodeValidation',
                }]

                const currentUser = getOperator(user, data.cashier, data.forceCashier);
                if (currentUser && currentUser.name && currentUser.inn) requestData.request[0].operator = currentUser;

                request.data = {
                    ...request.data,
                    request: {
                        uuid: generateUUID(),
                        ...requestData
                    },                    
                };
                break;
            }
            default: {
                break;
            }
        }
        let result = {};

        try {
            if (data.type === 'getTaskResult') {
                let lastError = null;
                
                for (let attempt = 1; attempt <= 4; attempt++) {
                    try {
                        const response = await sendRequestToConnector(request);
                        
                        if (response && response.data && !response.data.error) {
                            result = response.data;
                            result.fiscalUUID = requestData.uuid;
                            if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'updateorder', value: false });
                            return result;
                        }

                        const error = (response && response.data && response.data.error) ? response.data.error : null;
                        const errorMessage = error ? error.message || error.description || error.toString() : null;
                        lastError = error ? error : 'unknown error';
                        if (attempt === 4) {
                            if (errorMessage && (errorMessage.includes('no connection') || errorMessage.includes('Extension response timeout') || errorMessage.includes('signal is aborted without reason'))) {
                                const ping = await dispatch(pingExtension());
                                if (ping) {
                                    lastError = { code: 101, description: 'Не удалось установить соединение с ККТ. Проверьте настройки/подключение Web Request и ККТ.' };
                                } else {
                                    lastError = { code: 101, description: 'Не удалось установить соединение с расширением. Проверьте установлено ли у Вас расширение "CRM.ККТ.Соединение" версии не менее чем 2.2.1 и обновите страницу.' };
                                }
                            }
                            break;
                        }
                        
                        let timeout = 1000;
                        if (errorMessage && errorMessage.includes('signal is aborted without reason')) timeout = 2000;
                        await new Promise(resolve => setTimeout(resolve, timeout));
                        
                    } catch (error) {
                        const errorMessage = error ? error.message || error.description || error.toString() : null;
                        lastError = error ? error : 'unknown error';
                        if (attempt === 4) {
                            if (errorMessage && (errorMessage.includes('no connection') || errorMessage.includes('Extension response timeout') || errorMessage.includes('signal is aborted without reason'))) {
                                const ping = await dispatch(pingExtension());
                                if (ping) {
                                    lastError = { code: 101, description: 'Не удалось установить соединение с ККТ. Проверьте настройки/подключение Web Request и ККТ.' };
                                } else {
                                    lastError = { code: 101, description: 'Не удалось установить соединение с расширением. Проверьте установлено ли у Вас расширение "CRM.ККТ.Соединение" версии не менее чем 2.2.1 и обновите страницу.' };
                                }
                            }
                            break;
                        }
                        
                        let timeout = 1000;
                        if (errorMessage && errorMessage.includes('signal is aborted without reason')) timeout = 2000;
                        await new Promise(resolve => setTimeout(resolve, timeout));
                    }
                }
                
                result.error = lastError || { code: 101, description: 'max retries exceeded' };
                if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'updateorder', value: false });
                return result;
            }
            const response = await sendRequestToConnector(request);
            if (response.data.error) {
                result.error = response.data.error;
                const error = (response && response.data && response.data.error) ? response.data.error : null;
                const errorMessage = error ? error.message || error.description || error.toString() : null;
                if (errorMessage && errorMessage.includes('signal is aborted without reason')) result.fiscalUUID = requestData.uuid;
            } else {
                result = response.data;
                result.fiscalUUID = requestData.uuid;
            }
            if (!result.status && response.status) result.status = response.status;
            if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'updateorder', value: false});
            return result;
        } catch (error) {
            const errorMessage = error ? error.message || error.description || error.toString() : null;
            let oldError;
            if (comparisonVersionExtension(versionExtension, '2.2.2') && !old && (errorMessage.includes('Устройство по умолчанию не активно') || errorMessage.includes('Соединение с устройством ID'))) {
                const getDeviceInfo = await dispatch(requestAtol({...data, type: 'getDeviceInfo'}, false, true, true));
                if (getDeviceInfo.error) oldError = getDeviceInfo.error;
            }
            let returnUUID = false;
            if (errorMessage && errorMessage.includes('signal is aborted without reason')) returnUUID = true;

            if (errorMessage && (errorMessage.includes('no connection') || errorMessage.includes('Extension response timeout') || errorMessage.includes('signal is aborted without reason'))) {
                const ping = await dispatch(pingExtension());
                if (ping) {
                    result.error = { code: 101, description: 'Не удалось установить соединение с ККТ. Проверьте настройки/подключение Web Request и ККТ.'};
                    if (returnUUID) result.fiscalUUID = requestData.uuid;
                } else {
                    result.error =  { code: 101, description: 'Не удалось установить соединение с расширением. Проверьте установлено ли у Вас расширение "CRM.ККТ.Соединение" версии не менее чем 2.2.1 и обновите страницу.'};
                }
                return result;
            }
            
            if (error && error.response && error.response.data) {
                result.error = error.response.data.error;
            } else {
                let errorText = '';
                if (error && error.message) errorText += `${error.message} | `;
                if (oldError && oldError.message) errorText += `${oldError.message}`;
                if (!errorText) errorText = error ? error : 'error';
                result.error = { message: errorText };
            }
            if (!withoutLoader) dispatch({ type: 'SET_LOADER', field: 'updateorder', value: false});
            if (returnUUID) result.fiscalUUID = requestData.uuid;
            return result;
        }
        
    };
}

export function setDevicesList(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_DEVICES_LIST', data: data});
    }
}

export function setDevicesCount(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_DEVICES_COUNT', data: data});
    }
}

export function setDeviceDetail(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_DEVICE_DETAIL', data: data});
    }
}

export function setDevicesFilters(filters) {
    return dispatch => {
        dispatch({ type: 'SET_DEVICES_FILTERS', filters });
    }
}

export function setDevicesPaging(paging) {
    return dispatch => {
        dispatch({ type: 'SET_DEVICES_PAGING', paging });
    }
}

export function fetchDevices() {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'devices', value: true });
        const filials = getState().handbook.filials;
        const filters = getState().cassa.devices.filters;
        const paging = getState().cassa.devices.paging;
        const user = getState().user.info;

        const params = {}

        if (filters.point) {
            params['point.id'] = filters.point.value;
        } else if (filials.length > 0) {
            params['point.id_in'] = filials.map(filial => filial.id);
        } else if (user.points.length > 0) {
            const pointIds = user.points.map(item => item.id);
            params['point.id_in'] = pointIds
        }

        if (filters.city) params['city.id'] = filters.city.value;
        if (filters.id) params['id'] = filters.id;
        if (filters.deviceId) params['deviceId'] = filters.deviceId;

        params['_sort'] = `id:desc`;
        params['_start'] = paging.start;
        params['_limit'] = paging.limit;
        
        try {
            const count = await request({ method: 'get', url: `${urls.devices}/count` });
            dispatch(setDevicesCount(count))
            const devices = await request({ method: 'get', url: urls.devices, params });
            dispatch(setDevicesList(devices));
            dispatch({ type: 'SET_LOADER', field: 'devices', value: false });
        } catch(error) {
            dispatch(setError(error, 'devices'));
            dispatch({ type: 'SET_LOADER', field: 'devices', value: false });
        }
    }
}

export function fetchDevice(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'device', value: true });

    return request({ method: 'get', url: `${urls.devices}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_DEVICE', data: response });
            dispatch({ type: 'SET_LOADER', field: 'device', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'device'));
            dispatch({ type: 'SET_LOADER', field: 'device', value: false });
            return null
        });
    }
}

export function addDevice(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'addDevice', value: true });
    data.city = data.point.city ? data.point.city : data.city;
    data.point = data.point.value ? data.point.value : data.point.id;
    data.ffd = data.ffd.value ? data.ffd.value : data.ffd;
    data.user = data.user ? (data.user.value ? data.user.value : data.user.id) : null;
    return request({ method: 'post', url: urls.devices, data })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'addDevice', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'addDevice'));
            dispatch({ type: 'SET_LOADER', field: 'addDevice', value: false });
            return false;
        });
    }
}

export function setAddDevice(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_ADD_DEVICE', data });
    }
}

export function setDeviceEdit(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_EDIT_DEVICE', data });
    }
}

export function deleteDevice(id) {
    return dispatch => {
        dispatch({ type: 'SET_LOADER', field: 'devices', value: true });
        return request({ method: 'delete', url: `${urls.devices}/${id}` })
            .then((response) => {
                return true;
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'devices'));
                return null
            })
            .finally(() => {
                dispatch(fetchDevices());
            });
    }
}

export function updateDevice(data) {
    return dispatch => {
        data.city = data.point.city ? data.point.city : data.city;
        data.point = data.point.value ? data.point.value : data.point.id;
        data.ffd = data.ffd.value ? data.ffd.value : data.ffd;
        data.user = data.user ? (data.user.value ? data.user.value : data.user.id) : null;
        dispatch({ type: 'SET_LOADER', field: 'device', value: true });
        return request({ method: 'put', url: `${urls.devices}/${data.id}`, data })
            .then((response) => {
                return true;
            })
            .catch(error => {
                dispatch(setError({ status: 507 }, 'device'));
                return null
            });
    }
}

const isValidMarkingCode = (code) => {
    if (!code || typeof code !== 'string') return false;
    if (code.length < 13 || code.length > 150) return false;
    if (code.length === 0) return false;
    
    return true;
};

/*const getTaskResult = (order, point) => {
    return async (dispatch) => {
        const paramsDevice = {};
        paramsDevice["point.id"] = parseInt(point.id);

        const device = await getDevice(paramsDevice);

        if (!device || !device.login || !device.port) {
            return {
                error: {
                    description: 'Нет данных об оборудовании или аккаунте АТОЛ.',
                }
            };
        }

        const requestAtolData = {
            host: device.host || 'http://127.0.0.1',
            port: device.port || 16732,
            login: device.login || null,
            password: device.password || null,
            type: 'getTaskResult',
            fiscalUUID: order.fiscalUUID,
        }

        return dispatch(requestAtol(requestAtolData));
    }
}

export function sendReceiptMark(order, point) {
    return async (dispatch) => {
        if (!order.fiscalized) return { error: 'Заказ не фискализирован.'}
        if (!order.fiscalUUID) return { error: 'Нет UUID фискализации.'}

        const products = order.goods.filter((good) => good.markedCodes && good.markedCodes.length > 0)
        .flatMap((good) => {
            return good.markedCodes.map((code) => {
                return {
                    cis: code,
                    product_cost: parseInt(parseFloat(good.price) * 100),
                }
            })
        });

        const documentData = await dispatch(getTaskResult(order, point));

        if (!documentData) return { error: 'Нет данных о фискальном чеке.'};
        if (documentData.error) return { error: `Ошибка выполнения запроса состояния: Код ошибки: ${documentData.error.code}, ${documentData.error.description}` }
        
        const fiscalData = documentData.results[0];
        if (fiscalData.error && fiscalData.error.code && fiscalData.error.code > 0) return { error: `Код ошибки: ${fiscalData.error.code ? fiscalData.error.code : 'NaN'}, ${fiscalData.error.description ? fiscalData.error.description : ''}, status: ${fiscalData.status ? fiscalData.status : 'NaN'}.`};
        
        try {
            const codes = products.map((product) => product.cis);                    
            const response = await dispatch(sendLMSell(point, codes));
            if (response.error) return(response.error);
            if (response.error_message) return({error_message: response.error_message});
            return true;
        } catch (error) {
            if (error) {
                return(error);
            } else {
                return({error_message: 'Неизвестная ошибка. Повторите попытку.'});
            }
        }
    }    
}*/

export function getStatusKKT(pointId) {
    return async () => {
        const paramsDevice = {};
        paramsDevice["point.id"] = parseInt(pointId);

        const device = await getDevice(paramsDevice);

        if (!device || !device.login || !device.password) return {error: {error_message: 'no device'}};

        const url = `${device.host ? device.host : 'http://127.0.0.1'}:${device.port ? device.port : '5995'}`;

        const requestData = {
            type: 'api_request',
            data: {
                user: device.login || null,
                password: device.password || null,
                url: `${url}/api/v2/operations/queryDeviceInfo`,
                request: { deviceID: null }
            }
        }

        try {
            const response = await sendRequestToConnector(requestData);
            const status = response.status;
            const data = response.data;
            if (status !== 200) return {error: {code: status, error_message: data.error}}
            
            if (data.errorCode || data.reason || data.error_message) return {
                error: 
                {
                    code: data.errorCode,
                    error_message: data.error_message ? data.error_message : data.reason ? data.reason : null,
                }
            };
            return true;
        } catch (error) {
            return {error: error};
        }

    }
}

export function getStatusLM(point) {
    return async () => {
        const paramsDevice = {};
        paramsDevice["point.id"] = parseInt(point.id);

        const device = await getDevice(paramsDevice);

        if (!device || !device.loginMark || !device.passwordMark) {
            return false;
        }

        const url = `${device.hostMark ? device.hostMark : 'http://127.0.0.1'}:${device.portMark ? device.portMark : '5995'}`;

        const requestData = {
            type: 'api_request',
            data: {
                user: device.loginMark || null,
                password: device.passwordMark || null,
                url: `${url}/api/v1/status`,
            }
        }

        try {
            const response = await sendRequestToConnector(requestData);
            const data = response.data;
            if (data.status !== 'ready') return false;
            if (data.errorCode || data.reason || data.error_message) return false;
            return true;
        } catch (error) {
            return false;
        }
    }
}

export function initLMMark(point) {
    return async () => {
        const paramsDevice = {};
        paramsDevice["point.id"] = parseInt(point.id);

        const device = await getDevice(paramsDevice);

        if (!device || !device.loginMark || !device.passwordMark) {
            return {
                error_message: 'Нет данных об оборудовании или аккаунте ЛМ ЧЗ.',
            };
        }

        if (!device.tokenMark) {
            return {
                error_message: 'Нет токена ЛМ ЧЗ.',
            };
        }

        const url = `${device.hostMark ? device.hostMark : 'http://127.0.0.1'}:${device.portMark ? device.portMark : '5995'}`;

        const requestData = {
            type: 'api_request',
            data: {
                user: device.loginMark || null,
                password: device.passwordMark || null,
                url: `${url}/api/v1/init`,
                request: {
                    token: device.tokenMark,
                }
            }
        }

        let result = {};

        try {
            const response = await sendRequestToConnector(requestData);
            result = response.data || {};
            result.status = response.status;
            if (result.error_message) return { error: result.error_message };
            if (result.errorCode || result.reason) {
                return ({ 
                    error: { code: result.errorCode ? result.errorCode : null },
                    error_message: result.reason ? result.reason : null,
                })
            }
            return result;
        } catch (error) {   
            if (error && error.response && error.response.data) {
                return {errorData: error.response.data.error, error: error.response.data.error_message};
            } else if (error && error.message) {
                return({ error_message: error.message });
            } else {
                return {error: error ? error : 'error'};
            }
        }
    }
}

/*async function sendLMOutCheck(device, code) {
    const url = `${device.hostMark ? device.hostMark : 'http://127.0.0.1'}:${device.portMark ? device.portMark : '5995'}`;

    const requestData = {
        type: 'api_request',
        data: {
            user: device.loginMark || null,
            password: device.passwordMark || null,
            url: `${url}/api/v1/cis/outCheck`,
            request: {
                cis_list: [code],
            }
        }
    }

    try {
        const response = await sendRequestToConnector(requestData);
        let result = {...response.data.results[0], sendedCode: code[0] };
        if (result.error_message) return { error: result.error_message };
        if (result.description && result.code !== 0) return { error: {error_message: result.description} };
        if (result.errorCode || result.reason) {
            return ({ 
                error: { 
                    code: result.errorCode ? result.errorCode : null,
                    error_message: result.reason ? result.reason : null,
                },                    
            })
        }
        return result;
    } catch (error) {   
        if (error && error.response && error.response.data) {
            return {errorData: error.response.data.error, error: error.response.data.error_message};
        } else if (error && error.message) {
            return({error: { error_message: error.message }});
        } else if (error && error.description) {
            return({error: { code: error.code ? error.code : error.errorCode ? error.errorCode : null, error_message: error.description }});
        } else {
            return {error: error ? error : 'error'};
        }
    }
}

export function sendLMSell(point, codes) {
    return async () => {
        const paramsDevice = {};
        paramsDevice["point.id"] = parseInt(point.id);

        const device = await getDevice(paramsDevice);

        if (!device || !device.loginMark || !device.passwordMark) {
            return {
                error_message: 'Нет данных об оборудовании или аккаунте ЛМ ЧЗ.',
            };
        }

        const url = `${device.hostMark ? device.hostMark : 'http://127.0.0.1'}:${device.portMark ? device.portMark : '5995'}`;

        const requestData = {
            type: 'api_request',
            data: {
                user: device.loginMark || null,
                password: device.passwordMark || null,
                url: `${url}/api/v1/cis/Sell`,
                request: {
                    cis_list: codes,
                }
            }
        }

        let result = {};

        try {
            const response = await sendRequestToConnector(requestData);
            result = response.data.results;
            if (result.error_message) return { error: {error_message: result.error_message} };
            if (result.errorCode || result.reason) {
                return ({ 
                    error: { 
                        code: result.errorCode ? result.errorCode : null,
                        error_message: result.reason ? result.reason : null,
                    },                    
                })
            }

            const errors = result.filter((res) => !res.success);
            if (errors && errors.length > 0) return { error: 'Ошибка регистрации факта продажи марикрованных товаров' }; //Возможно нужно проверять были ли какие-либо коды приняты.
            return result;
        } catch (error) {   
            if (error && error.response && error.response.data) {
                return {error: {...error.response.data.error, error_message: error.response.data.error_message}};
            } else if (error && error.message) {
                return({error: { error_message: error.message }});
            } else if (error && error.description) {
                return({error: { code: error.code ? error.code : error.errorCode ? error.errorCode : null, error_message: error.description }});
            } else {
                return {error: error ? error : 'error'};
            }
        }
    }
}

const getErrorsValidationStatus = (data) => {
    if (data.error && data.error.code && data.error.code !== 0) return { code: 100, error: data.error };
    const result = data.result;
    if (isEmpty(result)) return { error: { code: 101, description: 'Нет ответа.' }};
    if (result.driverError && result.driverError.code && result.driverError.code !== 0) return { error: {...data.error, code: data.error.code ? data.error.code : 102, message: 'Ошибка драйвера.'} };
    if (isEmpty(result.onlineValidation)) return { error: { code: 210, description: 'Нет данных о валидации кода.' }};
    const { itemInfoCheckResult, markOperatorResponse } = result.onlineValidation;

    if (!isEmpty(itemInfoCheckResult)) {
        const { imcCheckFlag, imcCheckResult, imcEstimatedStatusCorrect, imcStatusInfo } = itemInfoCheckResult;
        if (!imcCheckFlag) return { error: { code: 221, description: 'Код не был проверен в ФН и/или ИСМ.' }};
        if (!imcCheckResult) return { error: { code: 221, description: 'Код не прошел проверку в ФН и/или ИСМ.' }};
        if (!imcStatusInfo) return { error: { code: 221, description: 'Проверка статуса ИСМ не выполнена.' }};
        if (!imcEstimatedStatusCorrect) return { code: 221, error: { description: 'Не корректность сведения от ИСМ о планируемом статусе товара.' }};
    }
    
    if (!isEmpty(markOperatorResponse)) {
        const { responseStatus, itemStatusCheck } = markOperatorResponse;
        if (!responseStatus) return { code: 222, error: { description: 'Результат проверки КП КМ отрицательный.' }};
        if (!itemStatusCheck) return { code: 222, error: { description: 'Статус товара не корректен.' }};
    }

    if (!result.sentImcRequest) return { code: 211, error: { description: 'Запроса о проверке КМ не отправлен.' }};
    return null;
}*/

export function acceptMarkingCode(code, point, itemInfoCheckResult = {}, requestData = null) {
    return async (dispatch) => {
        let error = null;
        const ping = await dispatch(pingExtension())
        if (!ping) return { error: { message: '101. Не удалось установить соединение с расширением. Проверьте установлено ли у Вас расширение "CRM.ККТ.Соединение" версии не менее чем 2.2.1 и обновите страницу.'}}
        const versionExtension = ping.version;
        let requestAtolData = requestData;
        if (isEmpty(requestAtolData)) {
            const paramsDevice = {};
            paramsDevice["point.id"] = parseInt(point);
    
            const device = await getDevice(paramsDevice);
    
            if (!device || !device.login || !device.port) {
                dispatch({ type: 'SET_LOADER', field: 'workingShift', value: false });
                return {error: 'Нет данных об оборудовании или аккаунте АТОЛ.'};
            }
    
            requestAtolData = {
                host: device.host || 'http://127.0.0.1',
                port: device.port || 16732,
                login: device.login,
                password: device.password,
            }
        }

        const acceptMarkingCodeResult = await dispatch(requestAtol({ ...requestAtolData, type: 'acceptMarkingCode' }));
        let getStatusAcceptMarkingCodeResult;
        if (comparisonVersionExtension(versionExtension, '2.2.2')) {
            getStatusAcceptMarkingCodeResult = acceptMarkingCodeResult;
        } else {
            getStatusAcceptMarkingCodeResult = await dispatch(requestAtol({ ...requestAtolData, type: 'getTaskResult', fiscalUUID: acceptMarkingCodeResult.uuid }));
        }
        error = (getStatusAcceptMarkingCodeResult.results && getStatusAcceptMarkingCodeResult.results[0] && getStatusAcceptMarkingCodeResult.results[0].error) ? getStatusAcceptMarkingCodeResult.results[0].error : null;
        if (error && error.code !== 0) return error;
        return true;
    }
}

export function setBeginMarkingCodeValidation(point, code, withoutLoader) {
    return async (dispatch) => {
        const paramsDevice = {};
        paramsDevice["point.id"] = parseInt(point);
        let error = null;

        const device = await getDevice(paramsDevice);

        if (!device || !device.login || !device.port) {
            return {error: 'Нет данных об оборудовании или аккаунте АТОЛ.'};
        }

        const requestAtolData = {
            host: device.host || 'http://127.0.0.1',
            port: device.port || 16732,
            login: device.login,
            password: device.password,
            code
        }

        const ping = await dispatch(pingExtension())
        if (!ping) return { error: '101. Не удалось установить соединение с расширением. Проверьте установлено ли у Вас расширение "CRM.ККТ.Соединение" версии не менее чем 2.2.1 и обновите страницу.'}
        const versionExtension = ping.version;

        await dispatch(requestAtol({ ...requestAtolData, type: 'cancelMarkingCodeValidation' }));
        const beginMarkingValidationResult = await dispatch(requestAtol({ ...requestAtolData, type: 'beginMarkingCodeValidation' }));
        const getStatusBeginMarkingValidation = await dispatch(requestAtol({ ...requestAtolData, type: 'getTaskResult', fiscalUUID: beginMarkingValidationResult.uuid }));
        error = (getStatusBeginMarkingValidation.results && getStatusBeginMarkingValidation.results[0] && getStatusBeginMarkingValidation.results[0].error) ? getStatusBeginMarkingValidation.results[0].error : null;
        if (error && error.code !== 0) return error;

        let itemInfoCheckResult = {};
        while (true) {
            const getMarkingValidationStatusResult = await dispatch(requestAtol({ ...requestAtolData, type: 'getMarkingCodeValidationStatus' }));
            let getStatusMarkingValidationStatus;
            if (comparisonVersionExtension(versionExtension, '2.2.2')) {
                getStatusMarkingValidationStatus = getMarkingValidationStatusResult;
            } else {
                getStatusMarkingValidationStatus = await dispatch(requestAtol({ ...requestAtolData, type: 'getTaskResult', fiscalUUID: getMarkingValidationStatusResult.uuid }));
            }
            error = (getStatusMarkingValidationStatus.results && getStatusMarkingValidationStatus.results[0] && getStatusMarkingValidationStatus.results[0].error) ? getStatusMarkingValidationStatus.results[0].error : null;
            if (error && error.code !== 0) return error;
    
            const result = (getStatusMarkingValidationStatus && getStatusMarkingValidationStatus.results && getStatusMarkingValidationStatus.results[0]) ? getStatusMarkingValidationStatus.results[0] : null;
            if (result && result.result && result.result.ready) break;
        }

        if (error && error.code !== 0) return error;
        const acceptCode = await dispatch(acceptMarkingCode(code, point, itemInfoCheckResult, requestAtolData));
        if (acceptCode.error && acceptCode.error.code !== 0) return acceptCode.error;
        return true
    }
}

export function fetchPlannedRevenue(id) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'plannedRevenue', value: true });
        try {
            const response = await request({ method: 'get', url: `${urls.plannedRevenues}/${id}` });
            dispatch({ type: 'SET_CASSA', field: 'plannedRevenue', data: response });
            dispatch({ type: 'SET_LOADER', field: 'plannedRevenue', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'plannedRevenue'));
            dispatch({ type: 'SET_LOADER', field: 'plannedRevenue', value: false });
            return false;
        }
    }
}

export function fetchPlannedRevenues(params) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'plannedRevenue', value: true });
        try {
            const response = await request({ method: 'get', url: urls.plannedRevenues, params });
            return response;
        } catch (error) {
            return {error: error};
        }
    }
}

export function fetchOrCreatePlannedRevenues(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'plannedRevenue', value: true });
        try {
            const response = await request({ method: 'post', url: `${urls.plannedRevenues}/fetchOrCreate`, data });
            dispatch({ type: 'SET_CASSA', field: 'plannedRevenue', data: response });
            dispatch({ type: 'SET_LOADER', field: 'plannedRevenue', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'plannedRevenue'));
            dispatch({ type: 'SET_LOADER', field: 'plannedRevenue', value: false });
            return {error};
        }
    }
}

export function updatePlannedRevenue(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'plannedRevenue', value: true });
        try {
            await request({ method: 'put', url: `${urls.plannedRevenues}/${data.id}`, data });
            dispatch({ type: 'SET_CASSA', field: 'plannedRevenue', data: null });
            dispatch({ type: 'SET_LOADER', field: 'plannedRevenue', value: false });
            return true;
        } catch (error) {
            dispatch(setError(error, 'plannedRevenue'));
            dispatch({ type: 'SET_LOADER', field: 'plannedRevenue', value: false });
            return false;
        }
    }
}

export function fetchWage(id) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'wages', value: true });
        try {
            const response = await request({ method: 'get', url: `${urls.wages}/${id}` });

            if (response && !isEmpty(response.totalPayments) && response.totalPayments[0].id == null) {
                response.totalPayments = response.totalPayments.map((payment, index) => ({
                    id: index + 1,
                    ...payment,
                }));
            }

            if (response && !isEmpty(response.totalPayrolls) && response.totalPayrolls[0].id == null) {
                response.totalPayrolls = response.totalPayrolls.map((payment, index) => ({
                    id: index + 1,
                    ...payment,
                }));
            }

            dispatch({ type: 'SET_CASSA', field: 'wages', data: response });
            dispatch({ type: 'SET_LOADER', field: 'wages', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'wages'));
            dispatch({ type: 'SET_LOADER', field: 'wages', value: false });
            return false;
        }
    }
}

export function fetchWageWithStaff(id) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'wages', value: true });
        try {
            const response = await request({ method: 'get', url: `${urls.wages}/withStaff/${id}` });

            if (response && !isEmpty(response.totalPayments) && response.totalPayments[0].id == null) {
                response.totalPayments = response.totalPayments.map((payment, index) => ({
                    id: index + 1,
                    ...payment,
                }));
            }

            if (response && !isEmpty(response.totalPayrolls) && response.totalPayrolls[0].id == null) {
                response.totalPayrolls = response.totalPayrolls.map((payment, index) => ({
                    id: index + 1,
                    ...payment,
                }));
            }

            dispatch({ type: 'SET_CASSA', field: 'wages', data: response });
            dispatch({ type: 'SET_LOADER', field: 'wages', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'wages'));
            dispatch({ type: 'SET_LOADER', field: 'wages', value: false });
            return false;
        }
    }
}

export function fetchWages(params) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'wages', value: true });
        try {
            const response = await request({ method: 'get', url: urls.wages, params });
            return response;
        } catch (error) {
            return {error: error};
        }
    }
}

export function fetchOrCreateWages(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'wages', value: true });
        try {
            const response = await request({ method: 'post', url: `${urls.wages}/fetchOrCreate`, data });

            if (response && !isEmpty(response.totalPayments) && response.totalPayments[0].id == null) {
                response.totalPayments = response.totalPayments.map((payment, index) => ({
                    id: index + 1,
                    ...payment,
                }));
            }

            if (response && !isEmpty(response.totalPayrolls) && response.totalPayrolls[0].id == null) {
                response.totalPayrolls = response.totalPayrolls.map((payment, index) => ({
                    id: index + 1,
                    ...payment,
                }));
            }

            dispatch({ type: 'SET_CASSA', field: 'wages', data: response });
            dispatch({ type: 'SET_LOADER', field: 'wages', value: false });
            return response;
        } catch (error) {
            dispatch(setError(error, 'wages'));
            dispatch({ type: 'SET_LOADER', field: 'wages', value: false });
            return {error};
        }
    }
}

export function updateWages(data) {
    return async (dispatch) => {
        dispatch(resetError('wages'));
        dispatch({ type: 'SET_LOADER', field: 'wages', value: true });
        try {
            await request({ method: 'put', url: `${urls.wages}/${data.id}`, data });
            dispatch({ type: 'SET_CASSA', field: 'wages', data: null });
            dispatch({ type: 'SET_LOADER', field: 'wages', value: false });
            return true;
        } catch (error) {
            dispatch(setError(error, 'wages'));
            dispatch({ type: 'SET_LOADER', field: 'wages', value: false });
            throw error;
        }
    }
}

export function updateWithPayment(dataArticle, dataWage, wageId) {
    return async (dispatch, getState) => {
        dispatch(resetError('wages'));
        const user = getState().user.info;
        const id = dataArticle.workingShiftId ? dataArticle.workingShiftId : getState().cassa.workingShift.id;
        if (id && dataArticle && dataArticle.article) {
            dataArticle.article.author = user.name ? user.name : user.username;
            dataArticle.article.sum = roundToFixed(dataArticle.article.sum);
            if(!dataArticle.article.visible_datetime) dataArticle.article.visible_datetime = new Date();

            const sendedArticleData = { workingShiftId: id, article: dataArticle.article };

            dispatch({ type: 'SET_LOADER', field: 'wages', value: true });

            try {
                await request({ method: 'put', url: `${urls.wages}/updateWithPayment/${wageId}`, data: { dataArticle: sendedArticleData, dataWage } });
                dispatch({ type: 'SET_CASSA', field: 'wages', data: null });
                dispatch({ type: 'SET_LOADER', field: 'wages', value: false });
                return true;
            } catch (error) {
                dispatch(setError(error, 'wages'));
                dispatch({ type: 'SET_LOADER', field: 'wages', value: false });
                throw error;
            }
        }
    }
}

export function pingExtension() {
    return async () => {
        const requestData = { type: 'ping' };

        try {
            const response = await sendRequestToConnector(requestData);
            const status = response && response.status;
            if (!status || status !== "success") return false;
            return response || true;
        } catch (error) {
            return false
        }
    }
}